import React from "react";
import { Card } from "../modules/Settings/Subcategories";

export function SubCategoryCardPage(props) {
  return <Card {...props} />;
}
